<template>
  <v-card @click="playVideo = true" class="item" tile flat>
    <div
      class="
        overflow-hidden
        rounded
        position-relative
        cursor-pointer
        item-video-content
      "
    >
      <div class="d-flex align-center justify-center item-video-mask">
        <v-icon color="#ffffff" :size="mobile ? '40px' : '50px'">
          fa-play-circle
        </v-icon>
      </div>

      <video
        class="d-block item-video"
        :src="files + video"
        width="100%"
      ></video>

      <v-dialog
        content-class="dialog-video"
        v-model="playVideo"
        max-width="960px"
        eager
      >
        <div class="position-relative">
          <div class="model-close">
            <v-btn
              @click="playVideo = false"
              color="grey darken-3"
              width="38px"
              height="38px"
              depressed
              fab
            >
              <v-icon color="white" size="20"> fa-times </v-icon>
            </v-btn>
          </div>

          <video
            ref="video"
            class="black d-block item-video-modal"
            :src="files + video"
            controls
            width="100%"
          ></video>
        </div>
      </v-dialog>
    </div>
  </v-card>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: "",
    },
    video: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    playVideo: false,
  }),
  computed: {
    mobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },
  },
  watch: {
    playVideo() {
      const video = this.$refs.video;

      if (this.playVideo) video.play();
      else video.pause();
    },
  },
};
</script>

<style lang="scss" scoped>
.item {
  .item-video-content {
    .item-video-mask {
      bottom: 0;
      left: 0;
      opacity: 0.7;
      position: absolute;
      right: 0;
      top: 0;
      transition: all 0.1s linear;
    }

    &:hover {
      .item-video-mask {
        opacity: 1;
      }
    }

    .item-video {
      aspect-ratio: 9 / 12;
      -o-object-fit: cover;
      object-fit: cover;

      &:fullscreen {
        -o-object-fit: contain;
        object-fit: contain;
      }
    }
  }
}

.item-video-modal {
  aspect-ratio: 16 / 9;
  -o-object-fit: contain;
  object-fit: contain;
  width: 100%;
}
</style>
